import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { TokenJWT } from '../../models/token/token-jwt';
import { Storage } from '@ionic/storage-angular';

@Injectable({
  providedIn: 'root'
})
export class TokenService {
  private tokenSubject: BehaviorSubject<TokenJWT | undefined> =
    new BehaviorSubject<TokenJWT | undefined>(undefined);

  constructor(   
    private storage: Storage
  ) {}

  getToken(): Observable<TokenJWT | undefined> {
    return this.tokenSubject.asObservable();
  }

  async setToken(token: TokenJWT | undefined): Promise<void> {
    this.tokenSubject.next(token);
  }

  async clearToken(): Promise<void> {
    this.tokenSubject.next(undefined);
    this.storage.remove('jwtTokenBusiness');
  }
}
